module.exports = __webpack_public_path__ + "static/gallery3-e61e59a72560725dc9c94fa3cb33599c.png";